/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ShopStyled } from '../../shopSetting/assets/shopStyled';
import { Col, Collapse, Container, OverlayTrigger, Row } from 'react-bootstrap';
import { StyledTooltip } from '../../../app/components/styledComponents/StyledTooltip';
import InfoIcon from '../../../app/components/svgIcons/InfoIcon';
import FormikDropZone from '../../../app/components/formikComponents/FormikDropZone';
import {
  calculateProgress,
  formatFileSize,
  removeFileNameDots,
  uuidv4,
} from '../../../utils/helper';
import { toast } from 'react-toastify';
import CheckIcon from '../../../app/components/checkbox/CheckIcon';
import DeleteIcon from '../../../app/components/svgIcons/DeleteIcon';
import {
  useUploadImageMutation,
  useUploadImageToS3BucketMutation,
  useUploadVideoToS3BucketMutation,
} from '../../ImagesGallery/imagesGalleryApiSlice';
import useAuth from '../../../hooks/useAuth';
import { Form, Formik } from 'formik';
import StyledText from '../../../app/components/styledComponents/StyledText';
import DropDownIcon from '../../../app/components/svgIcons/DropDownIcon';
import PopupArrowIcon from '../../../app/components/svgIcons/PopupArrowIcon';
import moment from 'moment';
import FormikIconInput from '../../../app/components/formikComponents/FormikIconInput';
import FormikInputField from '../../../app/components/formikComponents/FormikInputField';
import FormikNewTagsSearch from '../../../app/components/formikComponents/FormikNewTagsSearch';
import StyledTopTag from '../../../app/components/styledComponents/StyledTopTag';
import AddIcon from '../../../app/components/svgIcons/AddIcon';
import { useDispatch } from 'react-redux';
import {
  setGalleryImages,
  setVideoUploadProgress,
} from '../../../app/services/imagesGallery';
import StyledInputProgressBar from '../../../app/components/styledComponents/StyledInputProgressBar';
import NewLinkIcon from '../../../app/components/svgIcons/link';
import { useSelector } from 'react-redux';
import StyledSwitch from '../../../app/components/styledComponents/StyledSwitch';

const StyledModal = styled(Modal)`
  .modal-dialog {
    form {
      display: grid;
    }
    ${({ theme }) => css`
      @media (min-width: ${theme?.breakpoints?.xl}px) {
        --bs-modal-width: 1402px;
      }
    `}

    ${({ ispreview }) =>
      ispreview === 'true' &&
      css`
        width: 90%;
        --bs-modal-width: 90%;
      `}
  }
  .modal-content {
    border-radius: 10px;
    font-family: ${({ theme }) => theme.fontFamily};

    ${({ ispreview }) =>
      ispreview === 'true' &&
      css`
        width: auto;
        margin: 0 auto;
      `}
  }

  .modal-header {
    color: ${({ theme }) => theme.heading};
    font-family: ${({ theme }) => theme.fontFamily};
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
    border-bottom: 1.5px solid ${({ theme }) => theme.dark70};
    .h4 {
      font-size: 20px;
    }
    z-index: 2;
  }
  .modal-footer {
    justify-content: space-between;
    padding: 1rem;
  }
  .disabled {
    pointer-events: none;
  }
`;

const StyledImageContainer = styled.div`
  position: relative;
  .delete-icon {
    background-color: ${({ theme }) => theme.white};
    position: absolute;
    right: -8px;
    padding: 6px;
    border-radius: 50%;
    top: -13px;
    color: ${({ theme }) => theme.error};
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
  }
`;

const StyledProductImagesContainer = styled.div`
  ._images-container {
    flex-wrap: wrap;
    gap: 1.5rem 0.5rem;
  }
`;

const StyledContentColumn = styled(Col)`
  height: 100%;
  overflow-x: auto;
`;

const StyledUserImage = styled.div`
  width: 96px;
  height: 96px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.primaryLight2};
  box-shadow: rgba(0, 0, 0, 0.05) 0 1px 2px 0;
  position: relative;
  border-radius: 0px;
  &.full-size {
    width: 100%;
    ${({ ispreview }) =>
      ispreview === 'true'
        ? css`
            height: auto;
          `
        : css`
            min-height: 400px;
            height: 100%;
            position: absolute !important;
            left: 0;
            top: 0;
          `}
  }
  &.active {
    border: 3px solid ${({ theme }) => theme.primary};
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: ${({ ispreview }) =>
      ispreview === 'true' ? 'cover' : 'contain'};
    object-position: center center;

    ${({ ispreview }) =>
      ispreview === 'true' &&
      css`
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 70vh;
      `}
  }

  .check-icon {
    display: none;
    position: absolute;
    color: ${({ theme }) => theme.white};
    padding: 3px 6px;
    z-index: 1;
  }

  &.active {
    .check-icon {
      display: block;
    }

    &:after {
      opacity: 1;
    }
  }

  &:after {
    content: '\\A';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.1);
    opacity: 0;
    transition: all 1s;
    -webkit-transition: all 1s;
  }
`;

const ImageInfoItem = styled.div`
  display: flex;
  gap: 0.5rem;
  width: 100%;
  padding: 0 2px;
  white-space: nowrap;

  p {
    &:not(:first-child) {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;

const formatTagIds = (images, tagsList) => {
  const formatImage = (image) => {
    return {
      ...image,
      tagDTOS: image.tagDTOS?.map((tag) => {
        const found = tagsList?.find((t) => t.name === tag.name);
        if (found) {
          return {
            ...tag,
            id: found.id,
          };
        }
        return tag;
      }),
    };
  };

  if (Array.isArray(images)) {
    if (!tagsList?.length) return images;
    return images.map(formatImage);
  } else if (typeof images === 'object' && images !== null) {
    return formatImage(images);
  } else {
    return images;
  }
};

const isSelectedTag = (id, selectedTags) =>
  selectedTags?.find((tag) => tag.id === id);

const UploadImagesPopUp = ({
  show,
  isFlorist,
  onCancel,
  singleEditImage,
  previewModal,
  handleImageEditOrSave,
  tags,
  isVideo = false,
  accept,
  setFieldValue,
  setImages,
  images,
  filter,
  selectedTab,
  categories = [],
}) => {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const [imageTags, setImageTags] = useState([]);
  const [activeImage, setActiveImage] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [sectionCollapsed, setSectionCollapsed] = useState('details');
  const [copied, setCopied] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(
    productImages.length === 0 ? null : null,
  );
  const VideoUploading = useSelector((state) => state.imagesGallery);

  const [uploadImagesToBucket] = useUploadImageToS3BucketMutation();
  const [uploadVideoToBucket] = useUploadVideoToS3BucketMutation();
  const [updateImage, { isLoading }] = useUploadImageMutation();

  const toggleSection = (id) => {
    setImageTags((prevSections) =>
      prevSections.map((section) =>
        section.id === id ? { ...section, open: !section.open } : section,
      ),
    );
  };

  const handleTagChange = (values, setFieldValue, checkbox) => {
    const tagDTOS = values[activeImage?.index]?.tagDTOS ?? [];

    if (isSelectedTag(checkbox.id, tagDTOS)) {
      setFieldValue(
        `${activeImage.index}.tagDTOS`,
        tagDTOS.filter((tag) => tag.id !== checkbox.id),
      );
    } else {
      setFieldValue(`${activeImage.index}.tagDTOS`, [...tagDTOS, checkbox]);
    }
  };

  const renderBackButton = (size) => (
    <StyledText
      name="Image back icon"
      color={`${activeImage.index < 1 ? 'dark60' : 'icon'}`}
      className={`mb-0 ${
        activeImage.index < 1 ? 'cursor-not-allowed disabled' : 'cursor-pointer'
      }`}
      onClick={() => {
        setActiveImage(() => productImages[activeImage.index - 1]);
        setSectionCollapsed('details');
      }}
    >
      <PopupArrowIcon rotate="left" className="m-0 d-flex" size={size} />
    </StyledText>
  );

  const renderForwardButton = (size) => (
    <StyledText
      name="Image forward icon"
      className={`mb-0 ${
        activeImage.index >= productImages.length - 1
          ? 'cursor-not-allowed disabled'
          : 'cursor-pointer'
      }`}
      color={`${
        activeImage.index >= productImages.length - 1 ? 'dark60' : 'icon'
      }`}
      onClick={() => {
        setActiveImage(() => productImages[activeImage.index + 1]);
        setSectionCollapsed('details');
      }}
    >
      <PopupArrowIcon rotate="right" className="m-0 d-flex" size={size} />
    </StyledText>
  );

  const renderInput = ({ label, component, isRequired, parentClass = '' }) => (
    <Row className={`mb-3 ${parentClass ?? ''}`}>
      {label && (
        <Col xs={12} md={5} className="text-end">
          <ShopStyled.NewFormLabel>
            <span className={`title _light ${isRequired ? 'required' : ''}`}>
              {label}
            </span>
          </ShopStyled.NewFormLabel>
        </Col>
      )}
      <Col xs={12} md={!label ? 12 : 7}>
        {component}
      </Col>
    </Row>
  );

  const handleImagesUploadProcess = async (files) => {
    try {
      const filteredFiles = files.filter((file) => {
        const fileSize = file.size / (1024 * 1024);
        if (fileSize <= 10) {
          return true;
        } else {
          return false;
        }
      });

      // Creating initial image DTO
      const initialImagesDTO = await Promise.all(
        filteredFiles?.map((file) => {
          return new Promise((resolve, reject) => {
            // Creating new image object to load dimensions
            const temporaryImageUrl = URL.createObjectURL(file);
            const img = new Image();
            img.src = temporaryImageUrl;

            img.onload = function () {
              const result = {
                uploading: true,
                progress: 0,
                uploadedBy: `${user.firstName} ${user.lastName}`,
                uploadedTo: '',
                fileSize: formatFileSize(file.size),
                dimension: `${img.width} by ${img.height} Pixels`,
                alternativeText: '',
                title: '',
                caption: '',
                description: '',
                copyLink: '',
                tagDTOS: [],
                imageDTO: {
                  fileName: removeFileNameDots(file?.name),
                  extension: file.type,
                  url: temporaryImageUrl,
                },
                originalFile: file,
                dummyId: uuidv4(),
              };

              resolve(result);
            };

            img.onerror = function (error) {
              reject(error);
            };
          });
        }),
      );

      setProductImages((prev) =>
        [...(prev ?? []), ...initialImagesDTO]?.map((item, index) => ({
          ...item,
          index,
        })),
      );
    } catch (error) {}
  };

  const handleVideoUploadProcess = async (files) => {
    try {
      // Assuming 'files' is an array with a single file
      const file = files[0];
      const fileSize = file.size / (1024 * 1024); // Convert size to MB

      // Check file size
      if (fileSize > 10) {
        setIsButtonDisabled('File size exceeds the 10MB limit.');

        throw new Error('File size exceeds the 10MB limit.');
      } else {
        setIsButtonDisabled(null);
      }

      // Create initial video DTO
      const result = await new Promise((resolve, reject) => {
        // Create new video object to load dimensions
        const temporaryVideoUrl = URL.createObjectURL(file);
        const video = document.createElement('video');
        video.src = temporaryVideoUrl;

        video.onloadedmetadata = function () {
          // Create canvas to capture video frame
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');

          // Set canvas size to video dimensions
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;

          // Draw the video frame onto the canvas
          context.drawImage(video, 0, 0, canvas.width, canvas.height);

          // Convert canvas to data URL
          const thumbnailUrl = canvas.toDataURL('image/jpeg');

          const videoDTO = {
            uploading: true,
            progress: 0,
            uploadedBy: `${user.firstName} ${user.lastName}`,
            uploadedTo: '',
            fileSize: formatFileSize(file.size),
            dimension: `${video.videoWidth} by ${video.videoHeight} Pixels`,
            alternativeText: '',
            index: 0,
            title: '',
            caption: '',
            description: '',
            isVideo: true,
            copyLink: '',
            tagDTOS: [],
            videoDTO: {
              fileName: removeFileNameDots(file?.name),
              extension: file.type,
              url: temporaryVideoUrl,
              thumbnailUrl: thumbnailUrl, // Include the thumbnail URL
            },
            originalFile: file,
            dummyId: uuidv4(),
          };

          resolve(videoDTO);
        };

        video.onerror = function (error) {
          reject(error);
        };
      });

      setProductImages([result]);
    } catch (error) {}
  };


  const saveImages = async (values) => {
    try {

      if (selectedTab !== 2) {
        values.forEach(obj => {
          obj.imageCategory = {
            id: selectedTab === 0 || selectedTab === 1 ? 80 : 81,
            name: selectedTab === 0 || selectedTab === 1 ? "Image" : "Product image"
          };
        });
      }

      const payload = {
        isFlorist: isFlorist === 'yourImages',
        floristImagesDTOS: values || [],
        ...(isFlorist === 'yourImages'
          ? {
              floristId: user?.floristId,
              shopName: user.floristDTO.companyName,
              uuid: user.floristDTO.uuid,
            }
          : {}),
      };

      if (payload.floristImagesDTOS?.every((image) => !image.originalFile)) {
        await updateImage(payload);
        handleImageEditOrSave(values);
        if (
          Array.isArray(filter?.staticTags) &&
          Array.isArray(values?.[0]?.tagDTOS)
        ) {
          const hasMatch = filter.staticTags.some((tag) =>
            values[0].tagDTOS.includes(tag),
          );

          if (!hasMatch) {
            // Remove the image with id === values[0].id
            const updatedImages = images.filter(
              (img) => img.id !== values[0].id,
            );
            // You can now use updatedImages or set it in state

            setImages(updatedImages);
          }
        }

        onCancel();
        setActiveImage(null);
        setProductImages([]);
        toast.success('Images uploaded successfully');
        return;
      }

      dispatch(
        setGalleryImages({
          images: payload.floristImagesDTOS,
          isFlorist: payload.isFlorist,
        }),
      );
      onCancel();

      await uploadImagesToBucket(payload);
      setActiveImage(null);
      setProductImages([]);
      toast.success('Images uploaded successfully');
      handleImageEditOrSave(null, 'initial');
    } catch (error) {}
  };

  const saveVideo = async (values) => {
    try {
      dispatch(
        setVideoUploadProgress({
          progress: 0,
        }),
      );
      const payload = {
        isFlorist: isFlorist === 'yourImages',
        floristVideoDTOS: values || {},
        ...(isFlorist === 'yourImages'
          ? {
              floristId: user?.floristId,
              shopName: user.floristDTO.companyName,
              uuid: user.floristDTO.uuid,
            }
          : {}),
      };

      setIsUploading(true);
      const response = await uploadVideoToBucket(payload);
      setIsUploading(false);
      if (response?.data) {
        setFieldValue('bgVideoUrl', response?.data);
      }
      onCancel();
      setActiveImage(null);
      setProductImages([]);
      toast.success('Video uploaded successfully');
    } catch (error) {
      console.error('error in header style9: ', error);
    }
  };

  useEffect(() => {
    setActiveImage();
    setSectionCollapsed('details');
  }, []);

  useEffect(() => {
    if (previewModal) {
      setActiveImage(singleEditImage);
      setSectionCollapsed('details');
      return;
    }

    setImageTags(tags);
    const formattedImage = formatTagIds(singleEditImage, tags);
    setActiveImage(formattedImage);
    setSectionCollapsed('details');
  }, [singleEditImage, tags]);

  useEffect(() => {
    setProductImages([]);
  }, []);

  if (previewModal) {
    return (
      <StyledModal
        show={show}
        onHide={() => {
          onCancel();
          setActiveImage(null);
        }}
        centered
        size="xl"
        ispreview={'true'}
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center justify-content-between w-100">
            <StyledText color="heading" $fontSize="24px" className="mb-0">
              {activeImage?.imageDTO?.fileName || 'Image'}
            </StyledText>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0">
          <Container>
            <Row>
              <Col className="p-md-5">
                <StyledUserImage
                  ispreview={'true'}
                  className={`cursor-pointer flex-center align-items-center justify-content-center full-size`}
                >
                  <img
                    loading="lazy"
                    src={activeImage?.imageDTO?.url}
                    alt={activeImage?.imageDTO?.fileName}
                    style={{
                      objectFit: 'contain',
                    }}
                  />
                  <div className="check-icon">
                    <CheckIcon />
                  </div>
                </StyledUserImage>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </StyledModal>
    );
  }

  const CopyLinkIcon = styled.span`
    position: relative;
    font-size: 18px;
    color: ${({ theme }) => theme.danger};
    cursor: pointer;
    z-index: 99;
    background: ${({ theme, transparent = false }) =>
      transparent ? 'transparent' : theme.grayBg};
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    display: flex;
    padding: 0;
    border-radius: 50%;

    &.edit-grp {
      padding: 2px 8px 4px 10px;
    }

    .edit-btn {
      top: 0;
      right: 10px;
    }
  `;

  return (
    <StyledModal
      show={show}
      onHide={() => {
        onCancel();
        setActiveImage(null);
      }}
      centered
      size="xl"
    >
      {activeImage ? (
        <Formik
          enableReinitialize
          initialValues={[...(singleEditImage ? [activeImage] : productImages)]}
          onSubmit={saveImages}
          render={({ values, setFieldValue, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title className="d-flex align-items-center justify-content-between w-100">
                  <StyledText color="heading" $fontSize="24px" className="mb-0">
                    {activeImage?.imageDTO?.fileName || 'Image'}
                    {' ( '}
                    {activeImage?.fileSize || '-'}
                    {' ) '}
                  </StyledText>
                  {!singleEditImage && (
                    <span className="d-flex gap-2 me-2">
                      {renderBackButton()}
                      {renderForwardButton()}
                    </span>
                  )}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                className="p-0"
                style={{
                  height: 'calc(100vh - 200px)',
                  maxHeight: 'calc(100vh - 200px)',
                }}
              >
                <div
                  style={{
                    maxHeight: 'calc(100vh - 200px)',
                    height: 'calc(100vh - 200px)',
                    overflow: 'auto',
                  }}
                >
                  <Container
                    style={{
                      height: 'calc(100vh - 200px)',
                      maxHeight: 'calc(100vh - 200px)',
                    }}
                  >
                    <Row
                      className="py-2"
                      style={{
                        height: 'calc(100vh - 200px)',
                        maxHeight: 'calc(100vh - 200px)',
                      }}
                    >
                      <Col xs={12} md={7} className="py-2 position-relative">
                        <StyledUserImage
                          className={`cursor-pointer flex-center align-items-center justify-content-center full-size position-relative`}
                        >
                          <img
                            loading="lazy"
                            src={activeImage?.imageDTO?.url}
                            alt={activeImage?.imageDTO?.fileName}
                          />
                          <div className="check-icon">
                            <CheckIcon />
                          </div>
                          <div
                            style={{
                              position: 'absolute',
                              right: '10px',
                              top: '10px',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              zIndex: 99,
                            }}
                          >
                            <OverlayTrigger
                              overlay={
                                <StyledTooltip>
                                  {copied ? 'Link Copied' : 'Copy Image Link'}
                                </StyledTooltip>
                              }
                            >
                              <CopyLinkIcon
                                className="image-btn delete-grp"
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    values[activeImage.index]?.imageDTO?.url,
                                  );
                                  setCopied(true);
                                  setTimeout(() => setCopied(false), 500);
                                }}
                              >
                                <NewLinkIcon size={22} />
                              </CopyLinkIcon>
                            </OverlayTrigger>
                          </div>
                        </StyledUserImage>
                        {!singleEditImage && (
                          <StyledProductImagesContainer className="my-2 mt-3 mt-md-4 d-flex justify-content-between align-items-center">
                            {renderBackButton(30)}
                            <div className="d-flex _images-container align-items-center">
                              {productImages
                                ?.slice(
                                  Math.max(
                                    0,
                                    activeImage.index - Math.floor(5 / 2),
                                  ),
                                  Math.min(
                                    productImages.length - 1,
                                    Math.max(
                                      0,
                                      activeImage.index - Math.floor(5 / 2),
                                    ) +
                                      5 -
                                      1,
                                  ) + 1,
                                )
                                ?.map(({ imageDTO, id, ...product }) => (
                                  <StyledImageContainer key={id}>
                                    <StyledUserImage
                                      onClick={() => {
                                        setActiveImage({
                                          ...product,
                                          imageDTO,
                                          id,
                                        });
                                        setSectionCollapsed('details');
                                      }}
                                      className={`cursor-pointer flex-center align-items-center justify-content-center ${
                                        activeImage.dummyId === product.dummyId
                                          ? 'active'
                                          : ''
                                      }`}
                                    >
                                      <img
                                        loading="lazy"
                                        src={imageDTO?.url}
                                        alt={imageDTO?.fileName}
                                      />
                                    </StyledUserImage>
                                  </StyledImageContainer>
                                ))}
                            </div>
                            {renderForwardButton(30)}
                          </StyledProductImagesContainer>
                        )}
                      </Col>
                      <StyledContentColumn xs={12} md={5}>
                        <ShopStyled.BootstrapCollapseCard
                          style={{ backgroundColor: '#F8F8F8' }}
                          className="mb-2"
                        >
                          <div
                            className="d-flex justify-content-between align-items-center cursor-pointer"
                            onClick={() => {
                              setSectionCollapsed(
                                sectionCollapsed === 'details'
                                  ? null
                                  : 'details',
                              );
                            }}
                            aria-controls={`details-section`}
                            aria-expanded={sectionCollapsed == 'details'}
                          >
                            <StyledText
                              as="h5"
                              $fontSize="20px"
                              color="heading"
                              $fontWeight="600"
                            >
                              Details
                            </StyledText>
                            <StyledText color="icon" className="mb-0 ">
                              <DropDownIcon
                                rotate={`${
                                  sectionCollapsed === 'details' ? 'up' : ''
                                }`}
                              />
                            </StyledText>
                          </div>

                          <Collapse in={sectionCollapsed === 'details'}>
                            <div id="details-section" className="mt-2">
                              <ImageInfoItem>
                                <StyledText
                                  color="body"
                                  $fontSize="14px"
                                  $fontWeight="600"
                                  className="mb-0"
                                >
                                  Uploaded by :
                                </StyledText>
                                <StyledText
                                  color="body"
                                  $fontSize="14px"
                                  $fontWeight="400"
                                  className="mb-0"
                                  {...((activeImage?.uploadedBy ||
                                    user.firstName ||
                                    user.lastName) &&
                                  activeImage?.uploadedBy
                                    ? {
                                        title: activeImage?.uploadedBy,
                                      }
                                    : {
                                        title: `${user.firstName} ${user.lastName}`,
                                      })}
                                >
                                  {activeImage?.uploadedBy ||
                                  user.firstName ||
                                  user.lastName
                                    ? `${user.firstName} ${user.lastName}`
                                    : '-'}
                                </StyledText>
                              </ImageInfoItem>

                              <ImageInfoItem>
                                <StyledText
                                  color="body"
                                  $fontSize="14px"
                                  $fontWeight="600"
                                  className="mb-0"
                                >
                                  Uploaded on :
                                </StyledText>
                                <StyledText
                                  color="body"
                                  $fontSize="14px"
                                  $fontWeight="400"
                                  className="mb-0"
                                  {...(activeImage?.uploadedOn && {
                                    title: moment(
                                      activeImage?.uploadedOn,
                                    ).format('MMMM D, YYYY'),
                                  })}
                                >
                                  {activeImage?.uploadedOn
                                    ? moment(activeImage?.uploadedOn).format(
                                        'MMMM D, YYYY',
                                      )
                                    : '-'}
                                </StyledText>
                              </ImageInfoItem>

                              <ImageInfoItem>
                                <StyledText
                                  color="body"
                                  $fontSize="14px"
                                  $fontWeight="600"
                                  className="mb-0"
                                >
                                  Type :
                                </StyledText>
                                <StyledText
                                  color="body"
                                  $fontSize="14px"
                                  $fontWeight="400"
                                  className="mb-0"
                                >
                                  {activeImage?.imageDTO?.extension || '-'}
                                </StyledText>
                              </ImageInfoItem>
                              <ImageInfoItem>
                                <StyledText
                                  color="body"
                                  $fontSize="14px"
                                  $fontWeight="600"
                                  className="mb-0"
                                >
                                  Dimensions :
                                </StyledText>

                                <StyledText
                                  color="body"
                                  $fontSize="14px"
                                  $fontWeight="400"
                                  className="mb-0"
                                  title={activeImage?.dimension || '-'}
                                >
                                  {activeImage?.dimension || '-'}
                                </StyledText>
                              </ImageInfoItem>

                              <hr />

                              {renderInput({
                                label: 'Alternative text',
                                component: (
                                  <>
                                    <FormikIconInput
                                      name={`${activeImage.index}.alternativeText`}
                                      id={`${activeImage.index}.alternativeText`}
                                      padding="6.4px 14px"
                                      placeholder=" "
                                      islight="true"
                                      maxLength={100}
                                    />
                                    <StyledInputProgressBar
                                      height={3}
                                      marginTop={5}
                                      marginBottom={5}
                                      percentage={calculateProgress(
                                        values?.[activeImage.index]
                                          ?.alternativeText,
                                        100,
                                      )}
                                    />
                                    <StyledText
                                      color="body"
                                      $fontSize="14px"
                                      $fontWeight="400"
                                      className="mb-0"
                                    >
                                      <span className="text-decoration-underline">
                                        Describe the purpose of the image.
                                      </span>{' '}
                                      Leave empty if the image is purely
                                      decorative
                                    </StyledText>
                                  </>
                                ),
                              })}

                              {renderInput({
                                label: 'Title',
                                component: (
                                  <>
                                    <FormikIconInput
                                      name={`${activeImage.index}.title`}
                                      id={`${activeImage.index}.title`}
                                      placeholder=" "
                                      padding="6.4px 14px"
                                      islight="true"
                                      maxLength={100}
                                    />
                                    <StyledInputProgressBar
                                      height={3}
                                      marginTop={5}
                                      marginBottom={5}
                                      percentage={calculateProgress(
                                        values?.[activeImage.index]?.title,
                                        100,
                                      )}
                                    />
                                  </>
                                ),
                              })}
                              {process.env
                                .REACT_APP_GALLERY_FILTER_LAYOUT_ENABLED ===
                                'true' && (
                                <>
                                  {renderInput({
                                    label: 'Category',
                                    component: (
                                      <>
                                        <StyledSwitch
                                          className="ml-2"
                                          disableText="Product Image"
                                          enableText="Image"
                                          width="250px"
                                          rightValue="40px"
                                          switchLabels
                                          btnWidth={120}
                                          checked={
                                            values?.[activeImage.index]
                                              ?.imageCategory?.id == 80
                                              ? true
                                              : false
                                          }
                                          onChange={(e) => {
                                            if (e) {
                                              setFieldValue(
                                                `${activeImage.index}.imageCategory`,
                                                {
                                                  id: 81,
                                                  name: 'Product Image',
                                                },
                                              );
                                            } else {
                                              setFieldValue(
                                                `${activeImage.index}.imageCategory`,
                                                {
                                                  id: 80,
                                                  name: 'Image',
                                                },
                                              );
                                            }
                                          }}
                                        />
                                      </>
                                    ),
                                  })}
                                </>
                              )}

                              {renderInput({
                                label: 'Description',
                                component: (
                                  <>
                                    <FormikInputField
                                      newInput
                                      isLight
                                      $phFontSize="18px"
                                      $phColor={'bodyMedium'}
                                      as="textarea"
                                      placeholder=" "
                                      rows="2"
                                      name={`${activeImage.index}.description`}
                                      id={`${activeImage.index}.description`}
                                      maxLength={100}
                                    />
                                    <StyledInputProgressBar
                                      height={3}
                                      marginTop={5}
                                      marginBottom={5}
                                      percentage={calculateProgress(
                                        values?.[activeImage.index]
                                          ?.description,
                                        100,
                                      )}
                                    />
                                  </>
                                ),
                              })}
                            </div>
                          </Collapse>
                        </ShopStyled.BootstrapCollapseCard>

                        <ShopStyled.BootstrapCollapseCard
                          style={{ backgroundColor: '#F8F8F8' }}
                          className="my-4"
                        >
                          <div
                            className="d-flex justify-content-between align-items-center cursor-pointer"
                            onClick={() => {
                              setSectionCollapsed(
                                sectionCollapsed === 'tags' ? null : 'tags',
                              );
                            }}
                            aria-controls={`tags-section`}
                            aria-expanded={sectionCollapsed === 'tags'}
                          >
                            <StyledText
                              as="h5"
                              $fontSize="20px"
                              color="heading"
                              $fontWeight="600"
                            >
                              Tags
                            </StyledText>
                            <StyledText color="icon" className="mb-0 ">
                              <DropDownIcon
                                rotate={`${
                                  sectionCollapsed == 'tags' ? 'up' : ''
                                }`}
                              />
                            </StyledText>
                          </div>

                          <Collapse in={sectionCollapsed == 'tags'}>
                            <div id="tags-section" className="mt-4">
                              {renderInput({
                                component: (
                                  <>
                                    <FormikNewTagsSearch
                                      name={`tagDTOSList`}
                                      placeholder="Select Tags"
                                      options={imageTags}
                                      setOptions={setImageTags}
                                      previousData={
                                        productImages[activeImage.index]
                                      }
                                      secondName={`tagDTOS`}
                                      arrayIndex={`${activeImage.index}`}
                                      isArrayValues
                                      disableSetNameField
                                      isFullWidth
                                    />
                                  </>
                                ),
                              })}
                              <hr className="mb-5" />
                              {imageTags
                                .filter(
                                  (option) =>
                                    !option.parentCategory &&
                                    option.childTags?.length > 0,
                                )
                                .map((option) => ({
                                  ...option,
                                  childTags: option.childTags.map(
                                    (childTag) => ({
                                      ...childTag,
                                      value: childTag.name,
                                      label: childTag.name,
                                    }),
                                  ),
                                }))
                                .map((section, index) => (
                                  <div key={`top-tags-${index}-${section.id}`}>
                                    <ShopStyled.BootstrapCollapseCard>
                                      <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer"
                                        onClick={() =>
                                          toggleSection(section.id)
                                        }
                                        aria-controls={`section-${section.id}`}
                                        aria-expanded={section.open}
                                      >
                                        <StyledText
                                          as="h5"
                                          $fontSize="20px"
                                          color="heading"
                                          $fontWeight="600"
                                        >
                                          {section?.name || 'heading'}
                                        </StyledText>
                                        <StyledText
                                          color="icon"
                                          className="mb-0 "
                                        >
                                          <DropDownIcon
                                            rotate={`${
                                              section.open ? 'up' : ''
                                            }`}
                                          />
                                        </StyledText>
                                      </div>
                                      <Collapse in={section.open}>
                                        <div id={`section-${section.id}`}>
                                          <div className="d-flex flex-wrap gap-3 my-2 my-md-3">
                                            {section.childTags.map(
                                              (checkbox, i) => (
                                                <StyledTopTag
                                                  key={`${checkbox.id}-${i}`}
                                                  className={`${
                                                    isSelectedTag(
                                                      checkbox.id,
                                                      values[activeImage?.index]
                                                        ?.tagDTOS,
                                                    )
                                                      ? 'active'
                                                      : ''
                                                  }`}
                                                  onClick={() => {
                                                    handleTagChange(
                                                      values,
                                                      setFieldValue,
                                                      checkbox,
                                                    );
                                                  }}
                                                >
                                                  {checkbox.name || 'tag'}
                                                  <AddIcon size="10px" />
                                                </StyledTopTag>
                                              ),
                                            )}
                                          </div>
                                        </div>
                                      </Collapse>
                                    </ShopStyled.BootstrapCollapseCard>
                                  </div>
                                ))}
                            </div>
                          </Collapse>
                        </ShopStyled.BootstrapCollapseCard>
                      </StyledContentColumn>
                    </Row>

                    <Row>
                      <Col></Col>
                    </Row>
                  </Container>
                </div>
              </Modal.Body>

              <Modal.Footer>
                <div className="d-flex justify-content-end gap-2 w-100">
                  <ShopStyled.EditButton
                    color={'heading'}
                    variant={'outline'}
                    type="button"
                    style={{
                      boxShadow: 'none',
                    }}
                    onClick={() => {
                      setActiveImage(null);
                      if (singleEditImage) {
                        onCancel();
                        setActiveImage(null);
                      }
                    }}
                  >
                    <ShopStyled.ButtonText>Cancel</ShopStyled.ButtonText>
                  </ShopStyled.EditButton>

                  <ShopStyled.EditButton
                    color={'primary'}
                    type="submit"
                    disabled={isLoading}
                    loading={isLoading}
                  >
                    <ShopStyled.ButtonText
                      className={'d-flex align-items-center'}
                    >
                      Save
                    </ShopStyled.ButtonText>
                  </ShopStyled.EditButton>
                </div>
              </Modal.Footer>
            </Form>
          )}
        />
      ) : (
        <Formik
          enableReinitialize
          initialValues={{}}
          onSubmit={async () => {}}
          render={({ setFieldValue, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton={!(isVideo && isUploading)}>
                <Modal.Title>
                  <StyledText color="heading" $fontSize="24px" className="mb-0">
                    Upload Media
                  </StyledText>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="p-2 p-md-5 pb-md-3">
                <div className={`p-2 p-md-3 `}>
                  {!isVideo && (
                    <ShopStyled.NewFormLabel>
                      <span className={`title `}>
                        Product {isVideo ? 'Video' : 'Images'}
                      </span>
                      <OverlayTrigger
                        overlay={
                          <StyledTooltip>
                            Product {isVideo ? 'Video' : 'Images'}
                          </StyledTooltip>
                        }
                      >
                        <span className="cursor-pointer ms-3 ">
                          <InfoIcon className="mb-1" />
                        </span>
                      </OverlayTrigger>
                    </ShopStyled.NewFormLabel>
                  )}
                  <div name="uploadImageDropDown">
                    <FormikDropZone
                      name="images"
                      id="images"
                      accept={accept}
                      label={isVideo ? 'Drag a Video or' : 'Drag a Photo or'}
                      onDrop={(val) => {
                        if (isVideo ? val?.length > 1 : val?.length > 10)
                          toast.warning(
                            'Maximum of 10 files can be uploaded at once',
                          );

                        const files = isVideo
                          ? val?.splice(0, 1)
                          : val?.splice(0, 10);
                        isVideo
                          ? handleVideoUploadProcess(files, setFieldValue)
                          : handleImagesUploadProcess(files, setFieldValue);
                      }}
                    />
                  </div>
                  <StyledProductImagesContainer className="my-2 mt-3 mt-md-4">
                    <div className="d-flex _images-container">
                      {productImages?.map(
                        ({ imageDTO, videoDTO, id, ...product }, ind) => (
                          <StyledImageContainer
                            key={ind}
                            className="position-relative"
                          >
                            <StyledUserImage
                              onClick={() => {
                                isVideo
                                  ? null
                                  : setActiveImage({
                                      ...product,
                                      imageDTO,
                                      id,
                                    });
                                setSectionCollapsed('details');
                              }}
                              className={`cursor-pointer flex-center align-items-center justify-content-center `}
                            >
                              <img
                                loading="lazy"
                                src={
                                  isVideo
                                    ? videoDTO?.thumbnailUrl
                                    : imageDTO?.url
                                }
                                alt={
                                  isVideo
                                    ? videoDTO?.fileName
                                    : imageDTO?.fileName
                                }
                              />
                              <div className="check-icon">
                                <CheckIcon />
                              </div>
                            </StyledUserImage>
                            <div
                              className="delete-icon cursor-pointer"
                              onClick={() =>
                                setProductImages((prevState) =>
                                  prevState
                                    .filter(
                                      (p, index) =>
                                        p.id !== id || ind !== index,
                                    )
                                    .map((image, index) => ({
                                      ...image,
                                      index,
                                    })),
                                )
                              }
                            >
                              <DeleteIcon />
                            </div>
                          </StyledImageContainer>
                        ),
                      )}
                    </div>
                  </StyledProductImagesContainer>
                  <StyledText $fontSize="14px" colorHex="#e53935">
                    {isButtonDisabled !== null && isButtonDisabled}
                  </StyledText>
                  <StyledText $fontSize="14px" color="bodyMedium">
                    {isVideo
                      ? 'MP4 is supported. Max file size is 10MB.'
                      : ' PNG/JPG/JPEG/WEBP/AVIF are supported. Max file size is 10MB.'}
                  </StyledText>
                  <StyledText $fontSize="14px" color="bodyMedium">
                    {!isVideo && 'Maximum of 10 files can be uploaded at once.'}
                  </StyledText>
                </div>
              </Modal.Body>

              <Modal.Footer
                className={
                  'd-flex align-items-center justify-content-end border-0 pb-2 pb-md-4 pt-0'
                }
              >
                {productImages.length > 0 && (
                  <>
                    <ShopStyled.EditButton
                      color={'heading'}
                      variant={'outline'}
                      disabled={isVideo && isUploading}
                      style={{
                        boxShadow: 'none',
                      }}
                      onClick={() => {
                        setProductImages([]);
                        onCancel();
                      }}
                    >
                      <ShopStyled.ButtonText>Cancel</ShopStyled.ButtonText>
                    </ShopStyled.EditButton>
                    <ShopStyled.EditButton
                      color={'primary'}
                      type="button"
                      disabled={(isVideo && isUploading) || isButtonDisabled}
                      loading={isVideo && isUploading}
                      onClick={() => {
                        isVideo
                          ? saveVideo(productImages[0])
                          : setActiveImage(productImages[0]);
                        setSectionCollapsed('details');
                      }}
                    >
                      <ShopStyled.ButtonText
                        className={'d-flex align-items-center'}
                      >
                        {isVideo && isUploading
                          ? VideoUploading?.videoProgress === 100
                            ? 'Verifying upload...'
                            : `Uploading (${VideoUploading?.videoProgress}%)`
                          : isVideo
                          ? 'Save'
                          : 'Next'}
                        <DropDownIcon rotate="right" className="ms-2 mb-0" />
                      </ShopStyled.ButtonText>
                    </ShopStyled.EditButton>
                  </>
                )}
              </Modal.Footer>
            </Form>
          )}
        />
      )}
    </StyledModal>
  );
};

UploadImagesPopUp.propTypes = {
  show: PropTypes.bool.isRequired,
  bodyText: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
};

export default UploadImagesPopUp;
